export enum OnBoardStatus {
  OnBoard,
  TemporaryAshore,
}
